import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { concatMap, take, tap } from 'rxjs/operators';

import {
  LoadedNotifications,
  PatchNotification,
  SeenAllNotifications,
} from './notifications.actions';

import { IAppState } from '../app.state';

const NOTIFICATIONS_API_URL = '/api/v2/notifications';
const NOTIFICATIONS_LIMIT = 40;

@Injectable()
export class NotificationsService {
  constructor(
    private http: HttpClient,
    private store: Store<IAppState>,
  ) {}

  populate(): Observable<any> {
    return this.fetchNotifications().pipe(
      tap((response) => {
        this.store.dispatch(LoadedNotifications(response.items));
      }),
    );
  }

  fetchNotifications(): Observable<any> {
    const params = new HttpParams().set(
      'limit',
      NOTIFICATIONS_LIMIT.toString(),
    );
    return this.http.get(NOTIFICATIONS_API_URL, { params });
  }

  setNotificationsAsSeen(): Observable<any> {
    const update = { seen: true };
    const updateNotifications = this.updateNotifications(update);
    const notificationsState = this.store.select('notifications').pipe(take(1));
    return updateNotifications.pipe(
      concatMap(() => notificationsState),
      tap(() => this.store.dispatch(SeenAllNotifications())),
    );
  }

  updateNotifications(update: any): Observable<any> {
    return this.http.put(NOTIFICATIONS_API_URL, update);
  }

  updateNotification(notification: any, update: any): void {
    this.http
      .put(`${NOTIFICATIONS_API_URL}/${notification._id}`, update)
      .subscribe(() => {
        const updatedNotification = { ...notification, ...update };
        this.store.dispatch(PatchNotification(updatedNotification));
      });
  }
}
